<template>
  <div class="container h-100" style="background-color: #fff;overflow-y: hidden;">
    <div class="header">
      <!--            筛选添加 -->
      <AccountSearchForm @onSubmit="onSubmit"/>
    </div>
    <account-table ref="refTable" :search-condition="searchCondition"/>
  </div>

</template>

<script>
import AccountSearchForm from "@/views/account/AccountSearchForm";
import AccountTable from "@/views/account/AccountTable";

export default {
  name: "AccountIndex",
  components: {
    AccountSearchForm, AccountTable
  },
  data() {
    return {
      searchCondition: {}
    }
  },
  methods: {
    onSubmit(searchCondition) {
      this.searchCondition = searchCondition
      // this.$nextTick(() => {
      //   this.$refs['refTable'].init(searchCondition)
      // })
    },
  }
}
</script>

<style scoped>

</style>
